import React from "react";
import { Button, FormControl, Modal } from "react-bootstrap";
import ManageStock from "../../Issuer/Identification/Details/ManageStock";

import {
  getNFeConfig,
  updateNFeConfig,
  getNFeXMLAuth,
  createNFeXMLAuth,
  deleteNFeXMLAuth,
} from "../../../../../api/nfe";
import { formatDocument } from "../../../../../utils";
import InputMask from "react-input-mask";
export default class NFeConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: {},
      loading: false,
      modal: {
        show: false,
        title: "",
        description: "",
      },
      allowedDocs: [],
      modalAddDocument: false,
      documentType: "cpf",
      documentvalue: "",
    };
    this._updateNFeConfig = this._updateNFeConfig.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onAuthorizeXMLAccess = this._onAuthorizeXMLAccess.bind(this);
  }
  async _getNFeConfig() {
    this.setState({ ...this, loading: true });
    getNFeConfig()
      .then((config) => this.setState({ ...this, config, loading: false }))
      .catch(() => this.setState({ ...this, loading: false }));

    await getNFeXMLAuth().then((allowedDocs) => this.setState({ allowedDocs }));
  }
  _updateLocalStorage() {
    let branch =
      window.localStorage.getItem("easygestorweb_current_branch") || undefined;
    if (branch) {
      branch = JSON.parse(branch);
      branch["fiscal_config"] = this.state.config;
      window.localStorage.setItem(
        "easygestorweb_current_branch",
        JSON.stringify(branch)
      );
    }
  }
  _updateNFeConfig() {
    this.setState({ ...this, loading: true });
    updateNFeConfig(this.state.config)
      .then((data) => {
        this._updateLocalStorage();
        if (window.location.search.includes("from=")) {
          window.location.href = window.location.search.split("from=")[1];
        }
        const modal = {
          show: true,
          title: "Configurações atualizadas",
          description:
            "As configurações para emissão de NFe foram atualizadas!",
        };
        this.setState({ ...this, loading: false, modal });
      })
      .catch(() => {
        const modal = {
          show: true,
          title: "Oops...",
          description:
            "Ocorreu um erro ao tentar salvar as configurações, por favor revise as informações e tente novamente daqui a pouco",
        };
        this.setState({ ...this, loading: false, modal });
      });
  }
  _onChange(e) {
    let { name: key, value } = e.target;
    const { config } = this.state;
    config[key] = value;
    this.setState({ ...this, config });
  }

  _onSetAddXMLAuth(value) {
    this._onChange({ target: { name: "add_xml_auth", value } });
  }

  async _onAuthorizeXMLAccess() {
    const value = this.state.documentvalue.replace(/\D+/g, "");
    const key = this.state.documentType;
    this.setState({ ...this, loading: true });

    const data = key === "cnpj" ? { cnpj: value } : { cpf: value };

    console.log(data);
    await createNFeXMLAuth(data).then().catch();
    window.location.reload();
  }
  componentDidMount() {
    this._getNFeConfig();
    window.scrollTo({ top: 0 });
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12 py-2">
            <h2>Configurações para emissão de NF-e</h2>
          </div>
          <div className="col-md-3 col-xs-12">
            <div className="form-group">
              <div className="form-label">Número</div>
              <FormControl
                data-cy-test="#nfe-settings-nfe-number"
                name="nfe_number"
                onChange={this._onChange}
                value={this.state.config.nfe_number}
                disabled={this.state.loading}
              />
            </div>
          </div>
          <div className="col-md-3 col-xs-12">
            <div className="form-group">
              <div className="form-label">Série</div>
              <FormControl
                data-cy-test="#nfe-settings-nfe-series"
                name="nfe_serie"
                onChange={this._onChange}
                value={this.state.config.nfe_serie}
                disabled={this.state.loading}
              />
            </div>
          </div>
          <div className="col-md-6 col-xs-12">
            <div className="form-group">
              <div className="form-label">
                <h3>Autorizar acesso ao XML da NFE ?</h3>
              </div>
              <div>
                <Button
                  onClick={() => this._onSetAddXMLAuth(true)}
                  variant={
                    this.state.config.add_xml_auth
                      ? "primary"
                      : "outline-success"
                  }
                >
                  SIM <i className="fas fa-check ml-2"></i>
                </Button>
                <Button
                  onClick={() => this._onSetAddXMLAuth(false)}
                  className="ml-3"
                  variant={
                    this.state.config.add_xml_auth ? "outline-danger" : "danger"
                  }
                >
                  NÃO <i className="fas fa-close ml-2"></i>
                </Button>
              </div>
            </div>
            <div
              className={this.state.config.add_xml_auth ? "d-block" : "d-none"}
            >
              <div className="d-flex justify-content-between">
                <h4> Documentos Autorizados </h4>
                <Button
                  size="sm"
                  onClick={() =>
                    this.setState({ ...this, modalAddDocument: true })
                  }
                >
                  Adicionar CNPJ <i className="fas fa-plus ml-2"></i>
                </Button>
              </div>
              <ul className="list-group mt-3">
                {this.state.allowedDocs.map((item, index) => {
                  const key = `nfe-config-authorized-document-${item.id}${index}`;
                  const document = formatDocument(item.doc);
                  return (
                    <li
                      className="list-group-item px-2 d-flex justify-content-between"
                      key={key}
                    >
                      <div>{document}</div>
                      <div
                        onClick={async () => {
                          if (this.state.loading) {
                            return;
                          }
                          this.setState({ ...this, loading: true });
                          deleteNFeXMLAuth({ id: item.id }).then().catch();
                          window.location.reload();
                        }}
                      >
                        <i
                          style={{ cursor: "pointer" }}
                          className="fas fa-trash-alt text-danger"
                        ></i>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <h3> Enviar a DANFE para o email do destinatário ? </h3>
            <select
              onChange={this._onChange}
              name="send_danfe_to_client"
              id="send_danfe_to_client"
              className="form-control"
            >
              <option
                value={true}
                selected={this.state.config.send_danfe_to_client === true}
              >
                Sim
              </option>
              <option
                value={false}
                selected={this.state.config.send_danfe_to_client === false}
              >
                Não
              </option>
            </select>
          </div>

          <div className="col-md-6">
            <h3> Utilizar código de barras do produto ? </h3>
            <select
              onChange={this._onChange}
              name="use_product_barcode"
              id="use_product_barcode"
              className="form-control"
            >
              <option
                value={true}
                selected={this.state.config.use_product_barcode === true}
              >
                Sim
              </option>
              <option
                value={false}
                selected={this.state.config.use_product_barcode === false}
              >
                Não
              </option>
            </select>
          </div>
          <hr />
          <div className="col-md-8 col-xs-12"></div>
          <div className="col-md-12">
            <div className="form-group">
              <div className="form-label">
                <span>Informações de fisco</span>
              </div>
              <FormControl
                name="nfe_fisco_information"
                onChange={this._onChange}
                as="textarea"
                value={this.state.config.nfe_fisco_information}
                disabled={this.state.loading}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <ManageStock />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Button
              onClick={this._updateNFeConfig}
              disabled={this.state.loading}
              data-cy-test="#nfe-settings-button-save-settings"
            >
              Salvar configurações
            </Button>
          </div>
        </div>
        <Modal show={this.state.modal.show}>
          <Modal.Header>
            <Modal.Title>
              <h2>{this.state.modal.title}</h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="lead">{this.state.modal.description}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              data-cy-test="#nfe-settings-button-confirm-changes"
              onClick={() => window.location.reload()}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.modalAddDocument}
          onHide={() =>
            this.setState({
              ...this,
              modalAddDocument: false,
              documentType: "cnpj",
              documentvalue: "",
            })
          }
        >
          <Modal.Header>
            <h3>Autorizar Acesso ao XML da NF-e</h3>
          </Modal.Header>
          <Modal.Body>
            <select
              disabled={this.state.loading}
              className="form-control mb-3"
              onChange={(e) =>
                this.setState({ ...this, documentType: e.target.value })
              }
            >
              <option selected={this.state.documentType === "cpf"} value="cpf">
                Pessoa Física (CPF)
              </option>
              <option
                selected={this.state.documentType === "cnpj"}
                value="cnpj"
              >
                Pessoa Jurícsa (CNPJ)
              </option>
            </select>
            <InputMask
              disabled={this.state.loading}
              autoFocus
              value={this.state.documentvalue}
              onChange={(e) =>
                this.setState({ ...this, documentvalue: e.target.value })
              }
              className="form-control"
              placeholder={`Informe o ${this.state.documentType}`}
              mask={
                this.state.documentType === "cpf"
                  ? "999.999.999-99"
                  : "99.999.999/9999-99"
              }
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this._onAuthorizeXMLAccess}
              disabled={this.state.loading}
            >
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Config/ConfigInForm/index.jsx